import { IconButton, Stack, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { InventoryPermissions } from "src/constants/permissions";
import { oneBranchHasPermission } from "src/utils";
import { useNavigate } from "react-router-dom";
import { useRestoreClientMutation } from "src/api/sales/clients";
import { LoadingButton } from "@mui/lab";

interface IAction {
  row: any;
  refetch: Function;
}

const TableActions = (props: IAction) => {
  const navigate = useNavigate();
  const { t: T } = useTranslation("general");
  const { row, refetch } = props;
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIS
  const { mutate, isPending, status, error } = useRestoreClientMutation();

  // permissions
  const deletePermission = oneBranchHasPermission(
    InventoryPermissions.deletePro,
  );

  const handleNavigate = () => {
    navigate(
      `/inventory/production/${row.id}/recipe${
        row.product_recipe_id ? `/${row.product_recipe_id}` : ""
      }`,
    );
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleRestore = () => {
    mutate(row.id);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: T("addedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || T("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack direction={"row"} spacing={"12px"} justifyContent={"center"}>
      {true && (
        <Tooltip title={T("delete")}>
          <LoadingButton
            variant="outlined"
            color="tertiary"
            onClick={handleOpen}
            loading={isPending}
          >
            {T("restore")}
          </LoadingButton>
        </Tooltip>
      )}

      <ConfirmPopup
        open={open}
        item={row.name}
        handleClose={handleClose}
        handleConfirm={handleRestore}
        isPending={isPending}
        subtitle={T("areYouWantToRestore")}
        title={T("restore")}
        noIcon
        confirmBtnText={T("confirm")}
        confirmBtnColor="primary"
      />
    </Stack>
  );
};
export default TableActions;
